import React from 'react';
import type { CompanionKind } from './companions';

/**
 * Hand-written feather-shaped SVG — the site's dominant icon idiom.
 *
 * Not react-icons, though /browse uses it: its IconType returns ReactNode, which
 * CRA's TypeScript 4.9.5 rejects in JSX, forcing the cast documented in
 * BrowseIcon.tsx — and BrowseIcon's glyph is sized for a 40px tinted square,
 * which is the wrong scale inside a 40px pill.
 *
 * The SHAPES still match what the site already draws, so nobody has to relearn
 * a picture: the western-notes figure is copied verbatim from the entry card
 * this row replaces, and the focus figure is moved off the header IconButton it
 * replaces.
 */
const glyph: React.SVGProps<SVGSVGElement> = {
  width: 16,
  height: 16,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

export const COMPANION_GLYPHS: Record<CompanionKind, React.ReactNode> = {
  meaning: (
    <svg {...glyph}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  westernNotes: (
    <svg {...glyph}>
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
    </svg>
  ),
  focus: (
    <svg {...glyph}>
      <polyline points="15 3 21 3 21 9" />
      <polyline points="9 21 3 21 3 15" />
      <line x1="21" y1="3" x2="14" y2="10" />
      <line x1="3" y1="21" x2="10" y2="14" />
    </svg>
  ),
};

/** The back-crumb arrow, shared by every companion page header. */
export const ArrowLeftGlyph: React.FC = () => (
  <svg {...glyph}>
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);
